module.exports = __webpack_public_path__ + "static/media/fake-notification-icon-1.cd31f55b.svg";